/*LIBRARY*/

/*COMPONENT*/
import TextFieldGroup from "../common_input/TextFieldGroup";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const RegisterStep3Page1 = ({
  first_name,
  last_name,
  name,
  onChange,
  errors,
  name_cb,
}) => {
  const language = localStorage?.language ? localStorage?.language : "ina";

  return (
    <>
      <TextFieldGroup
        Title={dict["First name"][language]}
        placeholder={`${dict["Enter your first name"][language]}`}
        name="first_name"
        value={first_name}
        onChange={onChange}
        error={errors?.first_name}
      />
      <TextFieldGroup
        Title={dict["Last name"][language]}
        placeholder={`${dict["Enter your last name"][language]}`}
        name="last_name"
        value={last_name}
        onChange={onChange}
        error={errors?.last_name}
      />
      <TextFieldGroup
        Title={"Username"}
        placeholder={`${dict["Enter your username"][language]}`}
        name="name"
        value={name}
        onChange={(e) => {
          const newValue = e.target.value.toLowerCase();
          if (newValue === '' || /^[a-z][a-z0-9]*$/.test(newValue)) {
            e.target.value = newValue;
            onChange(e)
          }
        }}
        error={errors?.name}
        onBlur={name_cb}
      />
    </>
  );
};

export default RegisterStep3Page1;
